<script setup lang="ts">
import { propTypes } from '@/utils/propTypes';
import { useSlots } from 'vue';

const slots = useSlots()

defineProps({
  titleHeight: propTypes.string.def('48px'),
  showFooter: propTypes.bool.def(true),
  footerHeight: propTypes.string.def('48px'),
  title: propTypes.string.def(''),
  titleBorder: propTypes.bool.def(false),
  showUnderFooter: propTypes.bool.def(false),
  underFooterH:propTypes.string.def('116px'),
})
</script>

<template>
  <div class="crd ">
    <div
      class="crd-header"
      :style="{height: titleHeight, borderBottom:titleBorder?'1px solid #c8c8c8':'none'}">
      <div class="crd-header-lft">
       <span v-if="title" class="crd-title">{{title}}</span> 
        <slot name="lftSlot">
        </slot>
      </div>      
      <div class="crd-header-rt">
        <slot name="tSlot">
        </slot>
      </div>
    </div>
    <div v-if="slots.default" class='crd-body'>
      <slot></slot>
    </div>
    <div v-if="showFooter" class="flex items-center px-[20px] justify-end" :style="{height: footerHeight}">
      <slot name="footer"></slot>
    </div>
    <div v-if="showUnderFooter" class="flex justify-between items-center px-[20px]" :style="{height: underFooterH}">
      <slot name="underFooter"></slot>
    </div>    
  </div>
</template>

<style lang="less" scoped>
.crd{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: var(--c-txt);
  overflow: hidden;
  &-header{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    &-lft,&-rt{
      display: flex;
      align-items: center;
      gap:8px;
    }
  }
  &-title{
    color: var(--c-txt);
    font-size: 18px;
    font-weight: bold;
  }
  &-body{
    width: 100%;
    flex: 1;
    overflow: auto;
    // padding: 0 20px;
  }
}

</style>